import React from "react";
import {
    Card,
    CardHeader,
    CardContent,
    Typography,
    IconButton,
    Box,
    Popover,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import NotificationItem from "./notificationItems";
import { useSelector,useDispatch } from "react-redux";
import { updateNotificationList } from "../statemanagement/notificationSlice";
import { NotificationMarkAsViewed } from "../statemanagement/asyncThunkAPI";
/**
 * styled component will make the notifiction item scrollable
 */
const ScrollArea = styled("div")(({ theme }) => ({
    flex: 1,
    overflowY: "auto",
    paddingRight: theme.spacing(1),
    "&::-webkit-scrollbar": {
        width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.grey[400],
        borderRadius: 3,
    },
}));

/*eslint-disable-next */
/**
 * @author Aston Kingsley
 * In this component we are showing the popup to show the notifications
 * @param {*} param0 
 * @returns 
 */
const NotificationBar = ({ anchorEl, handleClose, setAnchorEl }) => {
    const { hasNotifications, unreadCount, notifications } = useSelector((state) => state.notificationData);
    const open = Boolean(anchorEl);
    const dispatch = useDispatch();

    const onDismiss = (id) => { 
        const updatedNotification = notifications.filter((item)=> id !=item.id);
        dispatch(updateNotificationList(updatedNotification))
    };
    
    /**
     * function to make a particular notification to readed.
     */
    const onMarkAsRead = (id) => { 
        dispatch(NotificationMarkAsViewed(id))
    };

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={() => handleClose()}
            anchorReference="anchorPosition"
            anchorPosition={{ top: 60, left: window.innerWidth - 20 }} //to keep popover on right
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
                sx: {
                    width: 380,
                    height: window.innerHeight - 100, // total available height
                    borderRadius: 2,
                    boxShadow: 3,
                    display: "flex",
                    flexDirection: "column",
                },
            }}
        >
            <Card
                sx={{
                    flex: 1,
                    bgcolor: "background.paper",
                    border: "1px solid",
                    borderColor: "divider",
                    boxShadow: 0,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box
                    sx={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        bgcolor: "background.paper",
                        borderBottom: "1px solid",
                        borderColor: "divider",
                    }}
                >
                    <CardHeader
                        sx={{ pb: 1.5 }}
                        title={
                            <Box display="flex" alignItems="center" gap={1.2}>
                                {unreadCount > 0 ? (
                                    <NotificationsActiveIcon
                                        fontSize="small"
                                        color="primary"
                                    />
                                ) : (
                                    <NotificationsIcon
                                        fontSize="small"
                                        sx={{ color: "text.secondary" }}
                                    />
                                )}
                                <Typography variant="h6" sx={{ flexGrow: 0.5 }}>
                                    Notifications
                                </Typography>
                            </Box>
                        }
                        action={
                            <IconButton size="small" onClick={() => setAnchorEl(null)}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        }
                    />

                    {/* {hasNotifications && (
                        <Box display="flex" gap={1.2} px={2} pb={1.5}>
                            {unreadCount > 0 && (
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={onMarkAllAsRead}
                                    startIcon={<DoneAllIcon fontSize="small" />}
                                    sx={{
                                        fontSize: "0.75rem",
                                        textTransform: "none",
                                    }}
                                >
                                    Mark all read
                                </Button>
                            )}
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={onClearAll}
                                sx={{
                                    fontSize: "0.75rem",
                                    textTransform: "none",
                                    color: "error.main",
                                    borderColor: "error.light",
                                    "&:hover": {
                                        bgcolor: "error.lighter",
                                    },
                                }}
                            >
                                Clear all
                            </Button>
                        </Box>
                    )} */}
                </Box>

                {/* Notifications List */}
                <CardContent
                    sx={{
                        p: 0,
                        flex: 1, // take remaining height
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden", // prevent double scroll
                    }}
                >
                    {!hasNotifications ? (
                        <Box textAlign="center" py={6}>
                            <NotificationsIcon
                                sx={{ fontSize: 48, color: "text.disabled", mb: 1 }}
                            />
                            <Typography
                                variant="subtitle2"
                                color="text.secondary"
                                mt={1}
                            >
                                All caught up!
                            </Typography>
                            <Typography variant="caption" color="text.disabled">
                                No new notifications at the moment.
                            </Typography>
                        </Box>
                    ) : (
                        <ScrollArea>
                            <Box display="flex" flexDirection="column" gap={1.5} p={2}>
                                {notifications?.map((notification) => (
                                    <NotificationItem
                                        key={notification.id}
                                        notification={notification}
                                        onDismiss={onDismiss}
                                        onMarkAsRead={onMarkAsRead}
                                    />
                                ))}
                            </Box>
                        </ScrollArea>
                    )}
                </CardContent>
            </Card>
        </Popover>
    );
};

export default NotificationBar;
